// extracted by mini-css-extract-plugin
export default {"custom-reports-table":"customReportsTable_custom-reports-table__gO7Vl"};